import React from "react";
import ReactTable from "../../reactTable";
import { formattedDate } from "../../../constants/misc";
import { Link } from "react-router-dom";
import ViewIcon from "../../svgs/viewIcon";

const TopicsTable = ({ topics }) => {
  const tableData = React.useMemo(() => topics, [topics]);
  const columns = React.useMemo(
    () => [
      {
        header: "TOPIC",
        accessorKey: "name",
        cell: ({ row }) => {
          const { title, uuid, author, created } = row.original;
          return (
            <div className="cell topic">
              <div className="arr_line_1">
                <span style={{ marginRight: 4 }}>
                  <ViewIcon />
                </span>
                <Link to={"/forum-topic/" + uuid}>
                  <span dangerouslySetInnerHTML={{ __html: title }} />
                </Link>
              </div>
              <div className="arr_line_2">
                {author && (
                  <span className="transp_white">by {author.name}</span>
                )}
                <span className="yellow">{formattedDate(created)}</span>
              </div>
            </div>
          );
        },
      },
      {
        header: "REPLIES",
        accessorKey: "comment_forum.comment_count",
      },
      {
        header: "LAST POSTS",
        accessorKey: "comment_forum",
        cell: ({ getValue }) => {
          const value = getValue();
          return (
            <div
              className="cell tr_white lastposts"
              data-date="2018-11-10"
              data-title="LAST POSTS"
            >
              {value.last_comment_date && value.last_comment_name
                ? formattedDate(value.last_comment_date)
                : "n/a"}
            </div>
          );
        },
      },
    ],

    [topics]
  );

  return (
    <div className="nbg_table" style={{ marginTop: "1rem" }}>
      <ReactTable
        headerColumnClass={"table-header-column"}
        data={tableData}
        columns={columns}
        filter={false}
        pagination={false}
      />

      <div className="row tFooter" style={{ height: "50px" }} />
    </div>
  );
};

export default TopicsTable;
